import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, MapPin, Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-10 pb-8 md:pt-16 md:pb-12 px-4 overflow-hidden flex flex-col items-center text-center" data-id="element-149">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-150" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="relative z-10 max-w-4xl mx-auto" data-id="element-151">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-dark-lighter border border-gold/30 text-gold-light text-xs font-semibold tracking-wider mb-3" data-id="element-152">
          <span data-id="element-153">⭐</span> ACADEMIA HOLÍSTICA ARGENTINA <span data-id="element-154">⭐</span>
        </div>

        <div className="mb-3 inline-block" data-id="element-155">
          <span className="bg-gold text-dark font-bold px-3 py-1 text-xs uppercase tracking-widest rounded-sm" data-id="element-156">
            MEGAPACK SISTEMA SOBERANO
          </span>
        </div>

        <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold font-heading leading-tight mb-3 text-white" data-id="element-157">
          Reprogramá tu mente.{' '}
          <span className="text-gold-light" data-id="element-158">Recuperá el control.</span>
        </h1>

        <p className="text-base md:text-lg text-gray-300 mb-4 max-w-2xl mx-auto" data-id="element-159">
          PNL Aplicada — 6 Tomos + 6 Bonos
        </p>

        <motion.img src="https://cdn.magicpatterns.com/uploads/imV7skLBaXCKykF8o7oYsG/ChatGPT_Image_1_jul_2026,_23_42_14.png" alt="MegaPack Sistema Soberano — 6 Tomos + 6 Bonos de PNL Aplicada" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="w-full max-w-md md:max-w-lg mx-auto mb-4 rounded-lg drop-shadow-[0_0_40px_rgba(212,168,67,0.2)]" data-id="element-160" />

        <div className="flex flex-wrap justify-center gap-4 mb-4 text-xs md:text-sm text-gray-300 font-medium" data-id="element-161">
          <div className="flex items-center gap-1.5" data-id="element-162">
            <FileText className="w-4 h-4 text-gold" data-id="element-163" />
            <span data-id="element-164">100% PDF</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-165">
            <Zap className="w-4 h-4 text-gold" data-id="element-166" />
            <span data-id="element-167">Acceso en 5 min</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-168">
            <MapPin className="w-4 h-4 text-gold" data-id="element-169" />
            <span data-id="element-170">Hecho para Argentina</span>
          </div>
        </div>

        <motion.a href="#pricing" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-gold to-gold-light text-dark font-bold text-base md:text-lg rounded-lg shadow-[0_0_30px_rgba(212,168,67,0.3)] hover:shadow-[0_0_40px_rgba(212,168,67,0.5)] transition-all animate-pulse-slow mb-3" data-id="element-171">
          → QUIERO MI MEGAPACK AHORA
        </motion.a>

        <div className="flex flex-wrap justify-center items-center gap-3 md:gap-5 text-xs text-gray-400" data-id="element-172">
          <div className="flex items-center gap-1.5" data-id="element-173">
            <Shield className="w-3.5 h-3.5" data-id="element-174" />
            <span data-id="element-175">Garantía 7 días</span>
          </div>
          <span className="hidden sm:inline text-dark-border" data-id="element-176">|</span>
          <div className="flex items-center gap-1.5" data-id="element-177">
            <Lock className="w-3.5 h-3.5" data-id="element-178" />
            <span data-id="element-179">Pago seguro</span>
          </div>
          <span className="hidden sm:inline text-dark-border" data-id="element-180">|</span>
          <div className="flex items-center gap-1.5" data-id="element-181">
            <CreditCard className="w-3.5 h-3.5" data-id="element-182" />
            <span data-id="element-183">Mercado Pago</span>
          </div>
        </div>
      </motion.div>
    </section>;
}